import main from './arrows-move.svg';
import active from './arrows-move-filled.svg';
import disabled from './arrows-move-gestalt.svg';

export default { main, active, disabled };
